import script from "./Pro_leaderEN.vue?vue&type=script&setup=true&lang=js"
export * from "./Pro_leaderEN.vue?vue&type=script&setup=true&lang=js"

import "./Pro_leaderEN.vue?vue&type=style&index=0&id=d5903b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5903b90"]])

export default __exports__